import React from 'react'
import PropTypes from 'prop-types'
import {SGCard} from "../../component"

export const SGPaddingCard = props => <SGCard className="content-card-padding">{props.children}</SGCard>

SGPaddingCard.propTypes = {
    children: PropTypes.any,
}